import { FC } from 'react';
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { City } from 'hotdesk_typescript';
import { buildLocationTrail } from '@/hotdesk-ui/helpers/location-trail';
import styles from './LocationBreadcrumb.module.scss';
interface LocationBreadcrumbProps {
  city?: City | null;
}

/**
 * Country › State › City under the page title, each linked to its explore
 * page. Same levels as the page's BreadcrumbList JSON-LD.
 */
const LocationBreadcrumb: FC<LocationBreadcrumbProps> = ({
  city
}) => {
  const t = useTranslations('workspace-details');
  const crumbs = buildLocationTrail(city);
  if (!crumbs.length) return null;
  return <nav aria-label={t('breadcrumb')} className={styles.nav} data-sentry-component="LocationBreadcrumb" data-sentry-source-file="LocationBreadcrumb.tsx">
            <ol className={styles.list}>
                {crumbs.map((crumb, index) => <li key={`${index}-${crumb.name}`} className={styles.item}>
                        {index > 0 && <ChevronRight size={14} className={styles.separator} aria-hidden="true" />}
                        {crumb.path ? <Link href={`/${crumb.path}`} className={styles.link}>
                                {crumb.name}
                            </Link> : <span>{crumb.name}</span>}
                    </li>)}
            </ol>
        </nav>;
};
export default LocationBreadcrumb;